import React, { useEffect, useState } from "react";
import SubHeaderMenu from "./Sidebar/SubHeaderMenu";
import { useLocation } from "react-router-dom";
import { Table } from "./Common/Table/Table";
import { BiSync } from "react-icons/bi";
import useNetworkServices from "../Networking/baseAPIManager";
import Button from "./Common/Button";
import Modal from "./Common/Modal ";
import Loader from "./Common/Loader";

const Enquiries = () => {
  const { generalEnquiries, queryUpdate } = useNetworkServices();
  const [enquiriesData, setEnquiriesData] = useState([]);
  const [viewData, setViewData] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const columns = [
    { header: "Name", accessor: "fullName" },
    { header: "Email Address", accessor: "email" },
    { header: "Phone", accessor: "mobile" },
    { header: "City", accessor: "city" },
    { header: "State", accessor: "state" },
    { header: "Subject", accessor: "subject" },
    {
      header: "Message",
      accessor: "message",
      customBtn: (data) => (
        <Button
          type="button"
          label="View"
          className="text-[#025D89]"
          onClick={() => {
            setViewData(data);
            setOpen(true);
          }}
        />
      ),
    },
  ];

  const generalEnquiriesList = async () => {
    setLoading(true);
    try {
      const response = await generalEnquiries();
      console.log(response?.data?.data, "response");
      setEnquiriesData(response?.data?.data);
    } catch (error) {
      console.error("Error :", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    generalEnquiriesList();
  }, []);

  const updateEnquiry = (enquiryId) => {
    const id = `?id=${enquiryId}`;
    try {
      const response = queryUpdate(id);
      console.log("Enquiry updated successfully", response);
      generalEnquiriesList();
    } catch (error) {
      console.error("Error updating enquiry:", error);
    }
  };

  return (
    <>
      <div id="main" className="px-4 sm:px-6 lg:px-8">
        <h1 className="font-bold text-2xl text-slate-900 pb-5">
          <SubHeaderMenu location={useLocation()} />
        </h1>
        <div className="border-[1px] border-[#DAE3F8] w-full h-auto p-4 mt-5 rounded-md">
          <Table columns={columns} data={enquiriesData} tableClass="h-[680px]"/>
        </div>
        {/* Modal Section */}
        <Modal
          isOpen={open}
          onClose={() => setOpen(false)}
          title="Message"
          Classes="w-auto md:w-1/2 lg:w-1/3 h-auto"
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 px-8 py-6 text-gray-700">
            <div className="flex flex-col gap-6">
              <p>
                <strong>Name :</strong> {viewData.fullName || "N/A"}
              </p>
              <p>
                <strong>Phone :</strong> {viewData.mobile || "N/A"}
              </p>
              <p>
                <strong>State :</strong> {viewData.state || "N/A"}
              </p>
            </div>
            <div className="flex flex-col gap-6">
              <p>
                <strong>Email :</strong> {viewData.email || "N/A"}
              </p>
              <p>
                <strong>Subject :</strong> {viewData.subject || "N/A"}
              </p>
              <p>
                <strong>City :</strong> {viewData.city || "N/A"}
              </p>
            </div>
          </div>
          <h4 className="px-8 pt-4 text-lg text-gray-700 font-bold ">
            Message
          </h4>
          <div className="p-6 mx-8 bg-gray-50 rounded-lg border border-gray-200 shadow-md overflow-auto break-words">
            <p className="text-sm text-gray-600">
              {viewData.message || "No message available"}
            </p>
          </div>
          <div className="px-8 py-6 flex justify-center">
            <Button
              type="button"
              className="px-6 py-2 bg-[#025D89] hover:bg-[#025c89c4] text-white rounded-md text-sm transition-all duration-150"
              label="Close"
              onClick={() => {
                setOpen(false);
                updateEnquiry(viewData._id);
              }}
            />
          </div>
        </Modal>
      </div>
      {loading && <Loader />}
    </>
  );
};

export default Enquiries;
